import { PushGatesCard } from './PushGatesCard';
import { fixtureGates } from './fixtures';
const meta = {
    title: 'Features/Settings/Technicians/PushHistory/PushGatesCard',
    component: PushGatesCard,
    parameters: { layout: 'padded' }
};
export default meta;
export const OneCategoryOptedOut = { args: { technicianName: 'Dana Whitfield', gates: fixtureGates } };
export const TenantPushOff = {
    args: {
        technicianName: 'Dana Whitfield',
        gates: fixtureGates.map((row) => (Object.assign(Object.assign({}, row), { gates: {
                tenantPush: 'off',
                tenantType: row.gates.tenantType,
                category: row.gates.category,
                device: 'not_checked'
            }, result: 'blocked', blockingGate: 'tenantPush' })))
    }
};
export const PlatformUnreachable = {
    args: {
        technicianName: 'Dana Whitfield',
        gates: fixtureGates.map((row) => (Object.assign(Object.assign({}, row), { gates: Object.assign(Object.assign({}, row.gates), { device: 'unknown' }), result: 'unknown', blockingGate: null })))
    }
};
